/**
 * horseUrlBuilder
 * Helper method for buildin url to horse profile
 * @param id
 * @param name
 * @returns {string}
 */
const horseUrlBuilder = (id, name) => {
    /**
     * Space should be replaced by hyphen,
     * while backslash and dot should be removed
     * in order to achieve proper url formatting.
     */
    const replaceMap = {
        ' ': '-',
        '\'': '',
        '.': ''
    };

    const urlName = name.toLowerCase().replace(/\s|'|./g, matched =>
        (typeof replaceMap[matched] !== 'undefined' ? replaceMap[matched] : matched)
    );

    return `/profile/horse/${id}/${urlName}`;
};

export default horseUrlBuilder;



// WEBPACK FOOTER //
// ./src/js/utils/horseUrlBuilder.js